import styled from 'styled-components';
import { Size } from '../../../types';
import LockSeedCheckbox from './FreezeSeedCheckbox';
import ShapeDropdown from './ShapeDropdown';
import CFGInputBox from './CFGInputBox';
import SeedInputBox from './SeedInputBox';
import { desktopMediaQuery } from '../../../styleHelpers';
import { isSuperEngine } from '../../../utils/engineHelpers';
import { useImageGenerationSettingsContext } from '../../../context/ImageGenerationSettingsProvider';
import { useGeneralContext } from '../../../context/GeneralContextProvider';

const AdvancedOptions = () => {
  const { seedState, setSeed, size, setSize, cfg, setCfg, engine } =
    useImageGenerationSettingsContext();

  const { isSeedFrozen, setIsSeedFrozen } = useGeneralContext();

  const handleSetSize = (size: Size) => {
    setIsSeedFrozen(true);
    setSize(size);
  };

  const shouldShowCfg = !isSuperEngine(engine);

  return (
    <Container>
      <ShapeDropdown size={size} setSize={handleSetSize} />
      <EmptyDiv />
      <EmptyDiv />
      <SeedContainer>
        <SeedInputBox seed={seedState} setSeed={setSeed} />
        <LockSeedCheckbox
          isSeedFrozen={isSeedFrozen}
          setIsSeedFrozen={setIsSeedFrozen}
        />
      </SeedContainer>
      <EmptyDiv />
      <EmptyDiv />
      {shouldShowCfg && <CFGInputBox cfg={cfg} setCfg={setCfg} />}
      <EmptyDiv />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${desktopMediaQuery} {
    width: 25vw;
  }
`;

const SeedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  margin-left: 14px;

  max-width: 90vw;
  max-width: 310px;
`;

const EmptyDiv = styled.div`
  height: 1rem;
`;

export default AdvancedOptions;
